export type NavigationCallback = (
	navigation: Navigation | string,
	options?: NavigationOptions
) => void;

export type Navigation = {
	path: string;
	queryString?: string;
	// Fragment should not include #
	fragment?: string;
};

export type NavigationOptions = {
	historyState?: any;
	shouldReplace?: boolean;
};

export type RouteParametersFromProps<
	TProps,
	TRequiredParameters extends StringKeyOf<TProps>,
	TOptionalParameters extends Exclude<StringKeyOf<TProps>, TRequiredParameters> = never
> = {
	[key in TRequiredParameters]: string;
} & {
	[key in TOptionalParameters]?: string;
};

export type QueryParametersFromProps<
	TProps,
	TParameters extends StringKeyOf<TProps>
> = {
	[key in TParameters]?: [NonNullable<TProps[key]>] extends [ReadonlyArray<string | number | boolean>]
		? readonly string[]
		: string;
};